export enum WaitlistImportStatus {
    Create = 1,
    Ignore = 2,
    Deactivate = 3,
    Skip = 4,
    Update = 5,
    NotOnWaitlist = 6,
    Inactive = 7,
    Deleted = 8
}